export default __webpack_public_path__ + "static/media/Others.aa8997c6.svg";